import React from 'react';

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null, errorInfo: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, errorInfo) {
    this.setState({ errorInfo });
    console.error('[ErrorBoundary] Erreur capturée:', error, errorInfo);

    // Chunk JS/CSS introuvable = build obsolète dans l'onglet (le fichier a changé de nom au
    // dernier déploiement). Un rechargement complet règle ça ; on ne le fait qu'une fois par
    // session d'onglet pour éviter une boucle si le problème persiste pour une autre raison.
    const isChunkError = error?.name === 'ChunkLoadError' || /loading (chunk|css chunk) [\w.]+ failed/i.test(error?.message || '');
    if (isChunkError && !sessionStorage.getItem('chunk-error-reloaded')) {
      sessionStorage.setItem('chunk-error-reloaded', '1');
      window.location.reload();
    }
  }

  handleReset = () => {
    this.setState({ hasError: false, error: null, errorInfo: null });
  };

  render() {
    if (this.state.hasError) {
      return (
        <div style={{ padding: '2rem', maxWidth: 600, margin: '2rem auto' }}>
          <div
            style={{
              background: 'var(--ui-color-bg, #fff)',
              border: '1px solid var(--ui-color-border, #dee2e6)',
              borderRadius: 'var(--ui-border-radius-lg, 0.75rem)',
              padding: '2rem',
              textAlign: 'center',
            }}
          >
            <h2 style={{ color: 'var(--ui-color-text, #212529)', marginBottom: '1rem' }}>
              Une erreur est survenue
            </h2>
            <p style={{ color: 'var(--ui-color-text-muted, #6c757d)', marginBottom: '1.5rem' }}>
              La page a rencontré un problème. Vous pouvez réessayer ou revenir à l'accueil.
            </p>
            {this.state.error && (
              <details style={{ textAlign: 'left', marginBottom: '1.5rem' }}>
                <summary style={{ cursor: 'pointer', color: '#dc3545', fontWeight: 600 }}>
                  Détails de l'erreur
                </summary>
                <pre
                  style={{
                    fontSize: '.8rem',
                    background: '#f8f9fa',
                    padding: '1rem',
                    borderRadius: '0.5rem',
                    overflow: 'auto',
                    maxHeight: 200,
                    marginTop: '0.5rem',
                  }}
                >
                  {this.state.error.toString()}
                  {this.state.errorInfo?.componentStack}
                </pre>
              </details>
            )}
            <div style={{ display: 'flex', gap: '0.75rem', justifyContent: 'center' }}>
              <button
                onClick={this.handleReset}
                style={{
                  padding: '0.5rem 1.5rem',
                  borderRadius: 'var(--ui-border-radius-md, 0.5rem)',
                  border: '1px solid var(--ui-color-border, #dee2e6)',
                  background: 'var(--ui-color-bg, #fff)',
                  cursor: 'pointer',
                  fontWeight: 600,
                }}
              >
                Réessayer
              </button>
              <button
                onClick={() => { window.location.href = '/'; }}
                style={{
                  padding: '0.5rem 1.5rem',
                  borderRadius: 'var(--ui-border-radius-md, 0.5rem)',
                  border: 'none',
                  background: 'var(--ui-color-primary, #00BE9E)',
                  color: '#fff',
                  cursor: 'pointer',
                  fontWeight: 600,
                }}
              >
                Retour à l'accueil
              </button>
            </div>
          </div>
        </div>
      );
    }

    return this.props.children;
  }
}

export default ErrorBoundary;
